






















































import { Vue, Component, Prop } from "@/shared/vuepack";
import * as Phone from "@/shared/phone";
import EmployerPhone from "@/employer/components/shared/EmployerPhone.vue";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployerUserStore } from "@/shared/store/employerUser";
import { useRoleStore } from "@/shared/store/role";
import { UserRoleNames } from "@/shared/types";

@Component({
  components: { EmployerPhone, Input, Button }
})
export default class AddEmployerUserForm extends Vue {
  notifierStore = useNotifierStore();
  employerUserStore = useEmployerUserStore();
  roleStore = useRoleStore();

  @Prop()
  employerId: number;

  @Prop()
  onSuccessCallback: () => void;

  $validator: Validator;

  classes = ["form-control"];

  emailAddress = "";
  firstName = "";
  lastName = "";
  isSubmitting = false;
  phone = "";
  jobTitle = "";
  selectedUserRoles: number[] = [];

  userRoles = [];

  created (): void {
    this.roleStore.getEmployerRoles();
  }

  get userRoleOptions () {
    return this.roleStore.employerRoles.map(role => ({text: role.displayName ? role.displayName : role.roleName, value: role.roleId}));
  }

  get canAdd (): boolean {
    return this.isSubmitting === false && !!this.emailAddress && !!this.firstName &&
      !!this.lastName && this.$validator.errors.any() === false;
  }

  onAdd (): void {
    if (this.canAdd === false) {
      return;
    }

    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;
      let roles: number[] = [this.roleStore.employerRoles.find(r => r.roleName === UserRoleNames.employerCensus).roleId];

      if (this.selectedUserRoles && this.selectedUserRoles.length) {
        roles = this.selectedUserRoles;
      }

      this.employerUserStore.addUser({
        employerId: this.employerId,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.emailAddress,
        phone: Phone.parse(this.phone),
        jobTitle: this.jobTitle,
        roles
      }).then((response: any) => {
        if (response.emailError) {
          this.notifierStore.setDanger("User added but email failed to send.");
        } else {
          if (response.reactivatingUser) {
            this.notifierStore.setSuccess(`${this.emailAddress} was previously an employer user and has been reactivated.`);
          } else {
            this.notifierStore.setSuccess(`${this.firstName} ${this.lastName} has been added as an employer user. ` +
              `An email has been sent to ${this.emailAddress} for confirmation`);
          }
          if (this.onSuccessCallback) {
            this.onSuccessCallback();
          }
        }

        this.emailAddress = "";
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.jobTitle = "";
        this.errors.clear();
      })
        .catch(() => {/* noop */ })
        .finally(() => {
          this.isSubmitting = false;
          this.$validator.reset();
        });
    });
  }
}
